"use strict";

exports.__esModule = true;
exports.setTrimLine = exports.setTransmissionType = exports.setSummaryExpand = exports.setSummaryDocked = exports.setPackages = exports.setModel = exports.setIncompatibleCodes = exports.setFuelType = exports.setFabric = exports.setDriveType = exports.setDataLossModal = exports.setColor = exports.setChangeModelModal = exports.setAccessories = exports.resetPreferences = exports.clearAllPreferences = void 0;
var setColor = function setColor(value) {
  return {
    type: 'configurator/SET_COLOR',
    value: value
  };
};
exports.setColor = setColor;
var setFabric = function setFabric(value) {
  return {
    type: 'configurator/SET_FABRIC',
    value: value
  };
};
exports.setFabric = setFabric;
var setFuelType = function setFuelType(value) {
  return {
    type: 'configurator/SET_FUEL_TYPE',
    value: value
  };
};
exports.setFuelType = setFuelType;
var setDriveType = function setDriveType(value) {
  return {
    type: 'configurator/SET_DRIVE_TYPE',
    value: value
  };
};
exports.setDriveType = setDriveType;
var setTransmissionType = function setTransmissionType(value) {
  return {
    type: 'configurator/SET_TRANSMISSION_TYPE',
    value: value
  };
};
exports.setTransmissionType = setTransmissionType;
var clearAllPreferences = function clearAllPreferences(value) {
  return {
    type: 'configurator/CLEAR_ALL_PREFERENCES',
    value: value
  };
};
exports.clearAllPreferences = clearAllPreferences;
var setModel = function setModel(value) {
  return {
    type: 'configurator/SET_MODEL',
    value: value
  };
};
exports.setModel = setModel;
var setTrimLine = function setTrimLine(value) {
  return {
    type: 'configurator/SET_TRIM_LINE',
    value: value
  };
};
exports.setTrimLine = setTrimLine;
var setPackages = function setPackages(value) {
  return {
    type: 'configurator/SET_PACKAGES',
    value: value
  };
};
exports.setPackages = setPackages;
var setAccessories = function setAccessories(value) {
  return {
    type: 'configurator/SET_ACCESSORIES',
    value: value
  };
};
exports.setAccessories = setAccessories;
var setIncompatibleCodes = function setIncompatibleCodes(value) {
  return {
    type: 'configurator/SET_INCOMPATIBLECODES',
    value: value
  };
};
exports.setIncompatibleCodes = setIncompatibleCodes;
var setSummaryExpand = function setSummaryExpand(value) {
  return {
    type: 'configurator/SET_SUMMARY_EXPAND',
    value: value
  };
};
exports.setSummaryExpand = setSummaryExpand;
var setSummaryDocked = function setSummaryDocked(value) {
  return {
    type: 'configurator/SET_SUMMARY_DOCKED',
    value: value
  };
};
exports.setSummaryDocked = setSummaryDocked;
var setDataLossModal = function setDataLossModal(value, step) {
  return {
    type: 'configurator/SET_DATA_LOSS_MODAL',
    value: value,
    step: step
  };
};
exports.setDataLossModal = setDataLossModal;
var setChangeModelModal = function setChangeModelModal(value) {
  return {
    type: 'configurator/SET_CHANGE_MODEL_MODAL',
    value: value
  };
};
exports.setChangeModelModal = setChangeModelModal;
var resetPreferences = function resetPreferences() {
  return {
    type: 'configurator/RESET_OPTIONS'
  };
};
exports.resetPreferences = resetPreferences;